import { COLORS } from 'assets/styled';
import styled from 'styled-components';

export const TriggerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: ${(props: ITriggerLabelProps) =>
    props.isDisabled ? 'not-allowed' : 'pointer'};
`;

interface ITriggerLabelProps {
  isActive: boolean;
  isDisabled: boolean;
}

export const TriggerLabel = styled.label`
  font-size: 16rem;
  cursor: ${(props: ITriggerLabelProps) =>
    props.isDisabled ? 'not-allowed' : 'pointer'};
  color: ${(props: ITriggerLabelProps) =>
    props.isDisabled
      ? COLORS.GRAY_300
      : props.isActive
      ? COLORS.GREEN
      : COLORS.BLACK};
  white-space: nowrap;
`;
